<template>
    <div>
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <MentorHeader v-if="this.userInfo.user.permission == 'mentor'" />
      <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
      <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
    </div>
    <router-view />
</template>

<script> 
import InstructorHeader from "@/components/Instructor/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import AdminHeader from "@/components/Admin/Header.vue";
import MentorHeader from "@/components/Mentor/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";

// import store from "@/store";
import { mapGetters } from "vuex";
// import store from "@/store";


export default {
  name: "Dashboard",
  components: {
    InstructorHeader,
    HodHeader,
    AdminHeader,
    MentorHeader, 
    CoordinateHeader
  },
  props: ["course_id", "department_id"],
  computed: mapGetters(["userInfo"]),
}

</script>